import React from 'react'
import Card from './Item'
import { useRouteMatch } from 'react-router-dom'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 10px;
  width: 820px;
  & > {
    margin-left: 10px;
  }
`
const Missing = styled.div`
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 20px;
  line-height: 20px;
  padding: 20px;
`

export default function List({
  rfps,
  onClickPublish,
  onClickRemove,
}: {
  rfps: RequestForProposal[]
  onClickPublish: (rfp: RequestForProposal) => void
  onClickRemove: (rfp: RequestForProposal) => void
}) {
  const { url } = useRouteMatch()
  return (
    <Container>
      {rfps.length ? (
        rfps.map((rfp) => (
          <Card
            key={rfp.id}
            rfp={rfp}
            url={url}
            onClickPublish={() => onClickPublish(rfp)}
            onClickRemove={() => onClickRemove(rfp)}
          />
        ))
      ) : (
        <Missing>No results found</Missing>
      )}
    </Container>
  )
}
